import { create } from 'zustand'
import { Permissions, User } from "../types/User"
import { enqueueSnackbar } from "notistack";

function parseJwt(token: string) {
    if(!token) return {}

    const base64Url = token.split('.')[1];
    if (!base64Url) {
        enqueueSnackbar({message: 'Invalid JWT token', variant: 'error'});
        return {}
    }
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    // Decode base64 string to JSON string
    const jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
    );

    return JSON.parse(jsonPayload);
}


export const useAuthStore = create<{
    jwt?:string;
    user?: User;
    setUser: (user?: User) => void;

    showLogin:boolean;
    setShowLogin(showLogin:boolean): void;
    showRegister:boolean;
    setShowRegister(setShowRegister:boolean): void;
    showResetPassword:boolean;
    permissions: Permissions,
    setShowResetPassword(showResetPassword:boolean): void;
    can(...permission: (keyof Permissions)[]): boolean,
    setJwt(jwt?:string): void;
    logout(navigate:(path:string) => void): void;
}>((set, get) => ({
    jwt: localStorage.getItem('realt_jwt') || undefined,
    user: undefined,
    setUser: (user?: User) => set({user}),
    showRegister: false,
    showLogin: false,
    showResetPassword: false,
    setShowLogin: (showLogin:boolean) => set({showLogin}),
    setShowRegister: (showRegister:boolean) => set({showRegister}),
    setShowResetPassword: (showResetPassword:boolean) => set({showResetPassword}),
    permissions: initPermissions(),
    can: function() {
        if(get().permissions['full_access']) {
            return true;
        }
        for(let i = 0; i < arguments.length; i++) {
            const permission = arguments[i] as keyof Permissions;
            if((get().permissions[permission])) {
                return true
            }
        }
        return false;
    },
    logout: (navigate:(path:string) => void) => {
        localStorage.removeItem("realt_jwt");
        navigate("/");
        //navigate("/logout");
        enqueueSnackbar("You have been logged out. Please come back later.")
        set({jwt: undefined, user: undefined, permissions: {}})
    },
    setJwt: (jwt:string) => {
        if(!jwt) {
            localStorage.removeItem('realt_jwt');
            set({jwt: undefined, permissions: {}})
            return;
        }
        localStorage.setItem("realt_jwt", jwt)
        const parsed = parseJwt(jwt)
        const permissions = (parsed.permissions as string[]).reduce((acc, curr) => {
            acc[curr] = true;
            return acc;
        }, {} as Record<string, boolean>);
        set({jwt, permissions})
    }
}))

function initPermissions() {
    const token = localStorage.getItem('realt_jwt');
    if(!token) {
        return {};
    }
    return ((parseJwt(token).permissions || []) as string[]).reduce((acc, curr) => {
        acc[curr] = true;
        return acc;
    }, {} as Record<string, boolean>)
}